<template>
  <vx-card class="list-view-item overflow-hidden" v-on="$listeners">
    <template slot="no-body">
      <div class="vx-row item-details no-gutter">
        <div class="vx-col sm:w-3/5">
          <div class="pt-8 pl-8 md:pb-8">
            <slot name="item-meta">
              <h6 class="item-name font-semibold mb-1 hover:text-primary cursor-pointer"
                  @click="navigate_to_detail_view">{{ item.name }}</h6>
              <p class="item-description text-sm">{{ item.description }}</p>
            </slot>
          </div>
        </div>

        <div
          class="vx-col sm:w-2/5 w-full flex items-center sm:border border-0 border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0">
          <div class="px-4 flex flex-col w-full">
            <div class="my-6 text-right">
              <h5 v-if="item.setup_fee > 0">Adesão <strong>{{ item.setup_fee * item.quantity | money(item.currency_code) }}</strong>
              <br>Mensal <strong>{{ item.fixed_price * item.quantity | money(item.currency_code) }}</strong></h5>
              <h5 v-else><strong>{{ item.fixed_price * item.quantity | money(item.currency_code) }}</strong></h5>
            </div>

            <slot name="action-buttons"/>
          </div>
        </div>
      </div>
    </template>
  </vx-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    isInWishList() {
      return (itemId) => this.$store.getters['eCommerce/isInWishList'](itemId)
    }
  },
  methods: {
    toggleItemInWishList(item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart(item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    cartButtonClicked(item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {
      }) : this.additemInCart(item)
    },
    navigate_to_detail_view() {
      this.$router.push({name: 'ecommerce-item-detail-view', params: {item_id: this.item.objectID}})
      .catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-view-item {
  .item-name, .item-description {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .item-name {
    -webkit-line-clamp: 2;
  }

  .item-description {
    -webkit-line-clamp: 5;
  }

  .grid-view-img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    transition: .35s;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, .25);

    .grid-view-img {
      opacity: 0.9;
    }
  }
}
</style>
